import { render, staticRenderFns } from "./BinnacleFilesStorage.vue?vue&type=template&id=467a9210"
import script from "./BinnacleFilesStorage.vue?vue&type=script&lang=js"
export * from "./BinnacleFilesStorage.vue?vue&type=script&lang=js"
import style0 from "./BinnacleFilesStorage.vue?vue&type=style&index=0&id=467a9210&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports